/**
 * @Date:   2018-01-22T14:02:25+08:00
 * @Last modified time: 2018-02-27T10:10:22+08:00
 */
import _util from '../../utils/';

const loginService = {
    login (userInfo, resolve, reject) {
        _util.request({
            url: '/api/auth/login',
            method: 'POST',
            data: userInfo,
            success: resolve,
            error: reject
        })
    },
    logout (resolve, reject) {
        _util.request({
            url: '/api/auth/logoff',
            method: 'POST',
            success: resolve,
            error: reject
        })
    },
    fetchAuthInfo (params, resolve, reject) {
        _util.request({
            url: '/api/auth/userinfo',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchUserAuthInfo (params, resolve, reject) {
        _util.request({
            url: '/api/auth/employee_userinfo',
            params: params,
            success: resolve,
            error: reject
        })
    },
    fetchUserMobileAuthInfo (params, resolve, reject) {
        _util.request({
            url: '/api/auth/mobile_userinfo',
            params: params,
            success: resolve,
            error: reject
        })
    },

}

export default loginService;



// WEBPACK FOOTER //
// ./src/services/Login/login-service.js